import { put, takeLatest, select } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as AccessorySlice from "./AccessorySlice";
import * as MobilitySlice from "../../Mobility/ducks/MobilitySlice";
import * as selectors from "./selectors";

function* getAccessories(params) {
  // old accessory API
  yield put(AccessorySlice.setAPIError(false));
  yield put(AccessorySlice.setPageLoading(true));
  try {
    const { offset, pageSize, sortBy, accessoryFilters, searchValue, selectedPhoneId } = params.payload;
    const requestBody = {
      approach: "",
      clientId: "MBT",
      creds: "",
      flow: "prospect",
      pageInfo: {
        offset: offset ?? 0,
        pageSize: pageSize ?? 20
      },
      accessoryFilters: accessoryFilters,
      selectedPhoneId: selectedPhoneId ?? "",
      shoppingPath: "PROSPECT",
      sortBy: sortBy,
      // searchValue: searchValue,
    };
    const resp = yield apiClient.post(API.GET_ACCESSORIES, requestBody);
    yield put(AccessorySlice.setAccessories(resp?.data?.data));
  } catch (err) {
    yield put(AccessorySlice.setAPIError(true));
  } finally {
    yield put(AccessorySlice.setPageLoading(false));
  }
}

function* getAccessoryList(params) {
  // new accessory API
  yield put(AccessorySlice.setAPIError(false));
  yield put(AccessorySlice.setPageLoading(true));
  const globalData = yield select(selectors.globalData);
  try {
    const { offset, pageSize, sortBy, accessoryFilters, searchValue, selectedPhoneId, oneTalk } = params.payload;
    const requestBody = {
      cartMeta: {
        // zipCode: "08870",
        ecpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId ?? "",
        sourceSystem: globalData?.widgetInputParams?.sourcesystem?.value ?? globalData?.widgetInputParams?.target?.value ?? window?.mbtGlobal?.sourceSystem ?? "",
        shoppingPath: globalData?.standAloneAccessoryFlow ? "EPBNAO" : "EPBNSE",
        approach: "",
        userId: globalData?.widgetInputParams?.mbLoginId?.value ?? globalData?.widgetInputParams?.loginUserId?.value ?? globalData?.widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId ?? "",
        rootEcpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.rootEcpdProfileId ?? "",
        clientId: globalData?.widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "MBT",
        flow: oneTalk ? "one-talk" : 'prospect'
      },
      selectedPhoneId: selectedPhoneId ?? "",
      pageInfo: {
        offset: offset ?? 0,
        pageSize: pageSize ?? 20
      },
      sortBy: sortBy,
      creds: "",
      accessoryFilters: accessoryFilters,
    }
    if (searchValue) {
      requestBody.searchPattern = searchValue;
    }
    const resp = yield apiClient.post(API.GET_ACCESSORY_LIST, requestBody);
    yield put(AccessorySlice.setAccessoryList(resp?.data));
  } catch (err) {
    yield put(AccessorySlice.setAPIError(true));
  } finally {
    yield put(AccessorySlice.setPageLoading(false));
  }

}
function* getAccessoryDetailPageInfo(params) {
  yield put(AccessorySlice.setAPIError(false));
  yield put(AccessorySlice.setPageLoading(true));
  try {
    const { deviceName, deviceId, categoryName, accessorySku } = params.payload;
    const globalData = yield select(selectors.globalData);
    const requestBody1 = {
      cartMeta: {
        ecpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId ?? "",
        shoppingPath: globalData?.standAloneAccessoryFlow ? "EPBNAO" : "EPBNSE",
        sourceSystem: globalData?.widgetInputParams?.sourcesystem?.value ?? globalData?.widgetInputParams?.target?.value ?? window?.mbtGlobal?.sourceSystem ?? "",
        approach: "",
        userId: globalData?.widgetInputParams?.mbLoginId?.value ?? globalData?.widgetInputParams?.loginUserId?.value ?? globalData?.widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId ?? "",
        rootEcpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.rootEcpdProfileId ?? "",
        clientId: globalData?.widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "MBT",
        flow: "prospect"
      },
      deviceRequest: {
        seo: deviceName,
        category: "accessories",
        deviceId: deviceId,
        skuId: accessorySku,
      },
    };
    const resp = yield apiClient.post(API.GET_ACCESSORY_DETAILS, requestBody1);
    yield put(AccessorySlice.setAccessoryDetails(resp?.data))
    // yield call(getCombinePricingInfo);
  } catch (err) {
    yield put(AccessorySlice.setAPIError(true));
  } finally {
    yield put(AccessorySlice.setPageLoading(false));
  }
}

function* getAccessoryReview(params) {
  yield put(AccessorySlice.setAPIError(false));
  yield put(AccessorySlice.setPageLoading(true));
  try {
    const { productId, limit, offset, sort } = params.payload;
    const reviewUrl =
      API.GET_REVIEWS +
      productId +
      "&Sort=" +
      sort +
      "&Limit=" +
      limit +
      "&Offset=" +
      offset + "&Filter=IsRatingsOnly:false";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const resp = yield apiClient.get(reviewUrl, config);
    yield put(AccessorySlice.setGetReviewsResponse(resp?.data));
  } catch (err) {
    yield put(AccessorySlice.setAPIError(true));
  } finally {
    yield put(AccessorySlice.setPageLoading(false));
  }
}

function* accessoryGridwallAddToCart(params) {
  yield put(AccessorySlice.setAPIError(false));
  yield put(AccessorySlice.setPageLoading(true));
  try {
    yield put(MobilitySlice.addToCart(params.payload));
    yield put(AccessorySlice.setAddToCartNotification({
      type: "info",
      show: true
    }))
  } catch (err) {
    console.err(err);
    yield put(AccessorySlice.setAPIError(true));
  } finally {
    yield put(AccessorySlice.setPageLoading(false));
  }
}

export default function* actionWatcher() {
  yield takeLatest(AccessorySlice.getAccessories.type, getAccessories);
  yield takeLatest(AccessorySlice.getAccessoryList.type, getAccessoryList);
  yield takeLatest(AccessorySlice.getAccessoryDetailPageInfo.type, getAccessoryDetailPageInfo);
  yield takeLatest(AccessorySlice.getAccessoryReview.type, getAccessoryReview);
  yield takeLatest(AccessorySlice.accessoryGridwallAddToCart.type, accessoryGridwallAddToCart);
}
